export default __webpack_public_path__ + "static/media/facebook-auth-color.3258399d.svg";